import React from "react";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { ScanStockUnitForm } from "../components";

export const ScanStockUnitPage: React.FC = () => {
  return (
    <>
      <Header title="Scanner un lot" subtitle="Enregistrer un mouvement de stock" />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Scan manuel" />
          <ScanStockUnitForm />
        </div>
      </div>
    </>
  );
};
